"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var Button_1 = (0, tslib_1.__importDefault)(require("@mui/material/Button"));
var Dialog_1 = (0, tslib_1.__importDefault)(require("@mui/material/Dialog"));
var DialogActions_1 = (0, tslib_1.__importDefault)(require("@mui/material/DialogActions"));
var DialogContent_1 = (0, tslib_1.__importDefault)(require("@mui/material/DialogContent"));
var DialogTitle_1 = (0, tslib_1.__importDefault)(require("@mui/material/DialogTitle"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var DropzoneAreaBase_1 = (0, tslib_1.__importDefault)(require("./DropzoneAreaBase")); // Split props related to DropzoneDialog from DropzoneArea ones

function splitDropzoneDialogProps(allProps) {
  var defaults = DropzoneDialogBase.defaultProps;
  var _allProps$cancelButto = allProps.cancelButtonText,
      cancelButtonText = _allProps$cancelButto === void 0 ? defaults.cancelButtonText : _allProps$cancelButto,
      _allProps$dialogProps = allProps.dialogProps,
      dialogProps = _allProps$dialogProps === void 0 ? defaults.dialogProps : _allProps$dialogProps,
      _allProps$dialogTitle = allProps.dialogTitle,
      dialogTitle = _allProps$dialogTitle === void 0 ? defaults.dialogTitle : _allProps$dialogTitle,
      _allProps$fullWidth = allProps.fullWidth,
      fullWidth = _allProps$fullWidth === void 0 ? defaults.fullWidth : _allProps$fullWidth,
      _allProps$maxWidth = allProps.maxWidth,
      maxWidth = _allProps$maxWidth === void 0 ? defaults.maxWidth : _allProps$maxWidth,
      onClose = allProps.onClose,
      onSave = allProps.onSave,
      _allProps$open = allProps.open,
      open = _allProps$open === void 0 ? defaults.open : _allProps$open,
      _allProps$submitButto = allProps.submitButtonText,
      submitButtonText = _allProps$submitButto === void 0 ? defaults.submitButtonText : _allProps$submitButto,
      dropzoneAreaProps = (0, tslib_1.__rest)(allProps, ["cancelButtonText", "dialogProps", "dialogTitle", "fullWidth", "maxWidth", "onClose", "onSave", "open", "submitButtonText"]);
  var dropzoneDialogProps = {
    cancelButtonText: cancelButtonText,
    dialogProps: dialogProps,
    dialogTitle: dialogTitle,
    fullWidth: fullWidth,
    maxWidth: maxWidth,
    onClose: onClose,
    onSave: onSave,
    open: open,
    submitButtonText: submitButtonText
  };
  var splitProps = [dropzoneDialogProps, dropzoneAreaProps];
  return splitProps;
}
/**
 * This component provides the DropzoneArea inside of a Material-UI Dialog.
 *
 * It supports all the Props and Methods from `DropzoneAreaBase`.
 */


var DropzoneDialogBase = /*#__PURE__*/function (_react_1$PureComponen) {
  _inherits(DropzoneDialogBase, _react_1$PureComponen);

  var _super = _createSuper(DropzoneDialogBase);

  function DropzoneDialogBase() {
    var _this;

    _classCallCheck(this, DropzoneDialogBase);

    _this = _super.apply(this, arguments);

    _this.handlePressClose = function (e) {
      var onClose = _this.props.onClose;
      onClose === null || onClose === void 0 ? void 0 : onClose(e, "backdropClick");
    };

    return _this;
  }

  _createClass(DropzoneDialogBase, [{
    key: "render",
    value: function render() {
      var _splitDropzoneDialogP = splitDropzoneDialogProps(this.props),
          _splitDropzoneDialogP2 = _slicedToArray(_splitDropzoneDialogP, 2),
          dropzoneDialogProps = _splitDropzoneDialogP2[0],
          dropzoneAreaProps = _splitDropzoneDialogP2[1];

      var cancelButtonText = dropzoneDialogProps.cancelButtonText,
          dialogProps = dropzoneDialogProps.dialogProps,
          dialogTitle = dropzoneDialogProps.dialogTitle,
          fullWidth = dropzoneDialogProps.fullWidth,
          maxWidth = dropzoneDialogProps.maxWidth,
          onClose = dropzoneDialogProps.onClose,
          onSave = dropzoneDialogProps.onSave,
          open = dropzoneDialogProps.open,
          submitButtonText = dropzoneDialogProps.submitButtonText; // Submit button state

      var submitDisabled = dropzoneAreaProps.fileObjects.length === 0;
      return react_1.default.createElement(Dialog_1.default, Object.assign({}, dialogProps, {
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        onClose: onClose,
        open: open
      }), react_1.default.createElement(DialogTitle_1.default, null, dialogTitle), react_1.default.createElement(DialogContent_1.default, null, react_1.default.createElement(DropzoneAreaBase_1.default, Object.assign({}, dropzoneAreaProps))), react_1.default.createElement(DialogActions_1.default, null, react_1.default.createElement(Button_1.default, {
        onClick: this.handlePressClose
      }, cancelButtonText), react_1.default.createElement(Button_1.default, {
        variant: "contained",
        disabled: submitDisabled,
        onClick: onSave
      }, submitButtonText)));
    }
  }]);

  return DropzoneDialogBase;
}(react_1.PureComponent);

DropzoneDialogBase.propTypes = Object.assign(Object.assign({}, DropzoneAreaBase_1.default.propTypes), {
  open: prop_types_1.default.bool,
  dialogTitle: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
  dialogProps: prop_types_1.default.object,
  fullWidth: prop_types_1.default.bool,
  maxWidth: prop_types_1.default.string,
  cancelButtonText: prop_types_1.default.string,
  submitButtonText: prop_types_1.default.string,
  onClose: prop_types_1.default.func,
  onSave: prop_types_1.default.func,
  showPreviews: prop_types_1.default.bool,
  showPreviewsInDropzone: prop_types_1.default.bool,
  showFileNamesInPreview: prop_types_1.default.bool
});
DropzoneDialogBase.defaultProps = {
  open: false,
  dialogTitle: "Upload file",
  dialogProps: {},
  fullWidth: true,
  maxWidth: "sm",
  cancelButtonText: "Cancel",
  submitButtonText: "Submit",
  showPreviews: true,
  showPreviewsInDropzone: false,
  showFileNamesInPreview: true
};
exports.default = DropzoneDialogBase;